import React, { useState } from "react";
import { motion } from "framer-motion";
import { Card } from "../../components/card/card";
import config from "../../config/config";
import { Charts } from "./plots/plots";
import { Table } from "./plots/table";
import { Select } from "../../components/form/inputs/select/select";
import { DynamicChart } from "./plots/chart";
import { useFetch } from "../../components/hooks/useFetch";
import { Loader } from "../../components/loader/loader";
import Icon from "../../components/icon/icon";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export function Analitycs() {
  const items = config.filters[0].items;
  const [selected, setSelected] = useState({
    label: items[0].label,
    value: items[0].values[0],
    date: items[0].dates[0],
  });
  const { data, loading, error } = useFetch(config.api.url);

  const setSelect = (select) => {
    items.forEach(({ label, values, dates }) => {
      if (label.includes(select.label)) {
        setSelected({ ...select, date: dates[values.indexOf(select.value)] });
      }
    });
  };

  const filteredData = Array.isArray(data)
    ? data.filter(
      ({ location, date }) =>
        selected.label.includes(location) && date && date.includes(selected.date)
    )
    : [];

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      <Loader loading={loading} error={error}>
        {/* Page Header */}
        <motion.div
          variants={itemVariants}
          className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200/60 pb-4"
        >
          <div>
            <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
              Análisis Estadístico de Contaminantes
            </h1>
            <p className="text-xs text-slate-500 font-medium mt-0.5">
              Cálculo de métricas descriptivas y series temporales por zona y horario
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1.5">
              <Icon className="text-primary">filter</Icon> Ubicación:
            </span>
            <Select
              items={items}
              change={setSelect}
              defaultValue={{ label: items[0].label, value: items[0].values[0] }}
            />
          </div>
        </motion.div>

        {/* Statistical Summary Table */}
        <motion.div variants={itemVariants} className="space-y-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse"></span>
              <h2 className="text-base font-bold text-slate-800">
                Resumen Estadístico — {selected.label} ({selected.value})
              </h2>
            </div>
            <span className="text-xs font-medium text-slate-400">
              {filteredData.length} registros evaluados
            </span>
          </div>

          <Table
            title={`${selected.label} - ${selected.value}`}
            data={filteredData}
          />
        </motion.div>

        {/* Charts Grid */}
        <motion.div variants={itemVariants} className="space-y-4 pt-4">
          <div className="flex items-center gap-2 border-b border-slate-100 pb-3">
            <Icon className="text-primary">chart-pie</Icon>
            <h2 className="text-lg font-bold text-slate-900">
              Gráficas de Dispersión y Series — {selected.label}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {Charts(data)
              .filter(({ key }) => key === selected.label)
              .map((plot, i) => (
                <motion.div
                  key={i}
                  whileHover={{ y: -4, transition: { duration: 0.2 } }}
                >
                  <Card className="p-5 flex flex-col justify-between h-full">
                    <div className="h-[360px] w-full">
                      <DynamicChart height={340} {...plot} />
                    </div>
                  </Card>
                </motion.div>
              ))}
          </div>
        </motion.div>
      </Loader>
    </motion.div>
  );
}


